import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

import { Button } from '@/components/form/button';

export const InstructionStep = () => {
  const { nextStep } = useWizard();
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col gap-4 py-10 md:py-16 md:px-20 text-lg">
        <p className="text-black-dark">{t('calibration.step1.text1')}</p>
        <ul className="pl-8 list-decimal text-black-dark flex flex-col gap-2">
          <li>{t('calibration.step1.text2')}</li>
          <li>{t('calibration.step1.text3')}</li>
        </ul>
      </div>
      <div className="flex justify-end">
        <Button onClick={nextStep}>{t('common.next')}</Button>
      </div>
    </>
  );
};
